import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Sticker from '../../model/sticker';
import Stickers from '../../collection/refbooks/stickers';
import StickerForm from './stickers.form';

import Config from '../../config';

import { roleA, roleAC, roleAI } from '../../roles';
import { restrict, } from '../../model/actions';
import { ask, } from '../../utils/popups';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/stickers.list',

    url() {
        return 'stickers';
    },

    open() {
        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: restrict( roleAC,
                () => this.trigger( StickerForm.OPEN_STICKER, 
                    new Sticker(),
                    this.state().cluster ) ),

            edit: restrict( roleAC,
                current => this.trigger( StickerForm.OPEN_STICKER, current.clone() ) ),
                
            destroy: restrict( roleAC, 
                
                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" stickers: with cluster == my cluster;
                    // there are only global and "my" stickers in the list;
                    // so, let's check only presence of cluster in sticker
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },

                current => {
                    const { page } = this.state();
                    // length will be updated by "destroy" call on model
                    const length = this.options.paged.length;

                    ask( 'sticker::modal delete - confirmation text',
                        'sticker::modal delete - title', 'actions::yes', 'actions::no',
                        () => this.options.source.destroy( current ) )
                        .then( () => {
                            if (length === 1 && page > 1)
                                    this.setState( { page: page - 1, } );
                        } )
                        .then( () => this.sort() )
                        .then( () => this.render() )
                        .then( () => this.navigated() );
                } )
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Stickers( this.options.stickers.models );
        this.options.sorted = new Stickers();
        this.options.filtered = new Stickers();
        this.options.paged = new Stickers( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/stickers.list.js